import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "v-exam-schedule" }
const _hoisted_2 = { class: "exam-schedule-header exam-step-flow disabled" }
const _hoisted_3 = { class: "exam-schedule-title" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Selecione a data que você deseja para ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "exam-step-flow-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-up" })
], -1)
const _hoisted_6 = {
  key: 1,
  class: "exam-schedule-form"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Data ")

import { computed, reactive, ref, watch } from "vue";
import { useHead } from "@vueuse/head";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

import { ObSpinner, ObCalendarInline } from "@/libs/components";

import { formatDate, formatDateEn } from "@/libs/utils";
import { Establishment } from "@/store/establishment/types";


export default /*#__PURE__*/_defineComponent({
  props: {
    flow: null,
    cd_estabelecimento: null
  },
  setup(__props: any) {

const props = __props as { flow: "laboratory" | "image", cd_estabelecimento: number }

useHead({ title: "Data e hora do exame | obmed" });



const store = useStore();
const router = useRouter();

const form = computed(() => store.state.exam.form);
const formItem = computed(() => form.value[props.cd_estabelecimento]);

const establishments = ref<{ [key: string]: Establishment[] }>({});
const availableDates = computed(() => Object.keys(establishments.value));
const selectedDate = computed({
  get() {
    return formItem.value.schedule || "";
  },
  set(value: string) {
    const cd_estabelecimento = formItem.value?.cd_estabelecimento;
    store.commit("setExamForm", { cd_estabelecimento, key: "schedule", value });

    const scheduleObj = establishments.value[formatDate(value)]?.[0]?.hr_horario?.find(
      (item) => item.ie_status === "L"
    );
    if (scheduleObj?.id) store.commit("setExamForm", { cd_estabelecimento, key: "scheduleId", value: scheduleObj?.id });
  },
});

const loading = reactive({ list: false });

async function getAvailableDates() {
  const cd_procedimento = formItem.value?.cd_procedimento || [];
  if (!cd_procedimento.length) return;

  const dispatchByFlow: any = { laboratory: "getAllEstablishmentByLaboratory", image: "getAllEstablishmentByExam" };

  loading.list = true;
  const response = await store.dispatch(dispatchByFlow[props.flow], {
    cd_procedimento,
    cd_estabelecimento: formItem.value.cd_estabelecimento,
    makeCommit: false,
  });
  loading.list = false;

  if (response && response.status < 300 && Object.keys(response.data).length) {
    establishments.value = response.data;
    selectedDate.value = formatDateEn(availableDates.value[0]);
  } else {
    store.commit("addToast", {
      summary: "Nenhum horário disponível no momento, tente novamente mais tarde!",
      severity: "warn",
    });
    router.back();
  }
}

watch(() => formItem.value?.cd_procedimento, getAvailableDates);

getAvailableDates();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("b", null, _toDisplayString(_unref(formItem).nm_estabelecimento), 1)
      ]),
      _hoisted_5
    ]),
    (_unref(loading).list)
      ? (_openBlock(), _createBlock(_unref(ObSpinner), {
          key: 0,
          style: {"margin-top":"4rem"}
        }))
      : (Object.keys(establishments.value).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_unref(ObCalendarInline), {
              modelValue: _unref(selectedDate),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedDate) ? (selectedDate).value = $event : null)),
              "element-id": `exam-schedule-calendar-date-${__props.cd_estabelecimento}`,
              validDates: _unref(availableDates)
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["modelValue", "element-id", "validDates"])
          ]))
        : _createCommentVNode("", true)
  ]))
}
}

})